import { Widgets } from '../index.d'

export default [{
  i: 'w-1-note',
  type: 'note',
  title: 'Note widget',
  visible: true,
  options: {
    backgroundColor: 'yellow',
    content: '<ul><li>Eggs</li><li>Milk</li><li>Bread</li></ul>'
  }
}, {
  i: 'w-2-smiley',
  type: 'smiley',
  title: 'Smiley widget',
  visible: true,
  options: {
    mood: '😁'
  }
}, {
  i: 'w-3-cat',
  type: 'cat',
  title: 'Cat midget',
  visible: true,
  options: {}
}] as Widgets
